import { Box } from '@mui/material'
import utils from 'helpers/utils'
import { Product } from 'type/types'

type ProductData = Pick<Product, 'id' | 'name' | 'nameFile' | 'visibility' | 'offer' | 'offer2'>

type Props = {
  product: ProductData
}

const SignUpProductPreviewMaven: React.FC<Props> = ({ product }) => {
  const { name, nameFile } = product

  return (
    <Box textAlign="center">
      <div style={{ height: 50 }} />
      <Box height="100px" mb="24px">
        {nameFile && (
          <img
            src={utils.getUrlFileMedia(nameFile)}
            alt={name}
            style={{
              width: '100px',
              height: '100px',
              borderRadius: '18px',
              border: '1px solid var(--black)',
            }}
          />
        )}
      </Box>

      <Box fontSize="21px">
        <h3 className="m-0 text-blue">{name}</h3>
        <h3 className="m-0 text-dark-blue">Sign up to request Proposal</h3>
      </Box>
    </Box>
  )
}

export default SignUpProductPreviewMaven
